var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetaEsquerda(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0108 20.5007C16.1416 20.3667 16.2148 20.1869 16.2148 19.9997C16.2148 19.8124 16.1416 19.6326 16.0108 19.4987L8.70126 12.0002L16.0108 4.50319C16.1416 4.36925 16.2148 4.18943 16.2148 4.00219C16.2148 3.81495 16.1416 3.63514 16.0108 3.50119C15.9472 3.43588 15.8711 3.38396 15.7871 3.34852C15.7032 3.31307 15.6129 3.29481 15.5218 3.29481C15.4306 3.29481 15.3404 3.31307 15.2564 3.34852C15.1724 3.38396 15.0964 3.43588 15.0328 3.50119L7.25977 11.4767C7.12324 11.6167 7.04684 11.8046 7.04684 12.0002C7.04684 12.1958 7.12324 12.3836 7.25977 12.5237L15.0328 20.4992C15.0964 20.5645 15.1724 20.6164 15.2564 20.6519C15.3404 20.6873 15.4306 20.7056 15.5218 20.7056C15.6129 20.7056 15.7032 20.6873 15.7871 20.6519C15.8711 20.6164 15.9472 20.5645 16.0108 20.4992V20.5007Z",
    fill: "#215044"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaEsquerda);
export default __webpack_public_path__ + "static/media/setaEsquerda.e968989ce15ce49e4a91c7dd1feb2d47.svg";
export { ForwardRef as ReactComponent };